import { jsxs, jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { InfoCircle } from '@zooplus/icons';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import style from './SponsoredTag.module.scss.js';

const { componentTestLabel } = getTestLabels('SponsoredTag');
const SponsoredTag = forwardRef((props, ref) => {
    const { children, className, ...otherProps } = props;
    return (jsxs("div", { "data-zta": componentTestLabel, ref: ref, className: classNames(className, style['z-sponsored-tag']), ...otherProps, children: [children, jsx(InfoCircle, { className: style['z-sponsored-tag__icon'], "aria-hidden": true })] }));
});
SponsoredTag.displayName = 'SponsoredTag';

export { SponsoredTag };
//# sourceMappingURL=SponsoredTag.js.map
